var SIDEBAR_NS = "sidebarFilters";

function onShowMoreFiltersClick(e) {
    var $btn = $(e.currentTarget);
    var $fieldset = $btn.closest("fieldset");
    $fieldset.find(".filter-more-items-wrap").first().slideDown(300);
    $btn.slideUp(200, function () { $btn.remove(); });
    $fieldset.removeClass("filter-has-more");
}

function onFilterSectionToggleClick(e) {
    var $h4 = $(e.currentTarget);
    $h4.nextAll().slideToggle(300);
    $h4.toggleClass("is-collapsed");
}

function bindSidebarClickOnce() {
    $(document).off("click." + SIDEBAR_NS, "#filters .show-more-filters")
        .on("click." + SIDEBAR_NS, "#filters .show-more-filters", onShowMoreFiltersClick);
    $(document).off("click." + SIDEBAR_NS, "#filters h4.filter-section-toggle")
        .on("click." + SIDEBAR_NS, "#filters h4.filter-section-toggle", onFilterSectionToggleClick);
}

function applySidebarFilters() {
    if (typeof shopDataLayer === "undefined" || !shopDataLayer.sidebar) return;
    if ($(".filter-stock-title").length === 0) {
        $("<h4 class='filter-stock-title'><span>" + shopDataLayer.sidebar.titles.stockFilter + "</span></h4>").prependTo('form[action="/action/ProductsListing/setStockFilter/"]');
    }
    if ($(".filter-symptoms-title").length === 0) {
        $("<h4 class='filter-symptoms-title'><span>" + shopDataLayer.sidebar.titles.symptomsFilter + "</span></h4>").prependTo('form[action="/action/ProductsListing/setDoubledotFilter/"]');
    }

    var maxItems = shopDataLayer.sidebar.maxItems;
    var showMoreHtml = shopDataLayer.sidebar.showMore || "Zobrazit více";
    $("#filters fieldset").each(function () {
        var $fieldset = $(this);
        if ($fieldset.hasClass("filter-has-more")) return;
        var $items = $fieldset.children("div").has("input[type='checkbox']").not(".advanced-filters-wrapper");
        var hasChecked = $fieldset.find("input[type='checkbox']:checked").length > 0;
        if (hasChecked || $items.length <= maxItems) return;
        var $hidden = $items.slice(maxItems);
        $hidden.wrapAll("<div class='filter-more-items-wrap'/>");
        $fieldset.find(".filter-more-items-wrap").first().hide();
        $fieldset.addClass("filter-has-more");
        $("<div class='show-more-filters'>" + showMoreHtml + "</div>").appendTo($fieldset);
    });

    $("#filters h4").each(function () {
        var $h4 = $(this);
        if ($h4.nextAll().length === 0) return;
        $h4.addClass("filter-section-toggle");
    });
}

$(document).ready(function () {
    bindSidebarClickOnce();
    applySidebarFilters();
});
document.addEventListener("ShoptetDOMContentLoaded", applySidebarFilters);